var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import drawRadar from '../utils/radar.js';
import { Getter, State } from 'vuex-class';
let Page1 = class Page1 extends Vue {
    handleCurrentWatch(e) {
        e === 1 && this.draw();
        e !== 1 && this.destoryIns();
    }
    destoryIns() { }
    draw() {
        const radarIns = this.$refs['radar'];
        radarIns.width = 228;
        radarIns.height = 208;
        drawRadar({
            el: '#radar',
            data: this.radarInfo,
            radius: 170,
            width: 350,
            height: 350,
            center: 175,
            total: 10,
            fillColor: '#FFB9BB',
            contentBorderColor: '#D86568',
            timer: 700,
        });
    }
};
__decorate([
    Getter
], Page1.prototype, "radarInfo", void 0);
__decorate([
    Getter
], Page1.prototype, "page1", void 0);
__decorate([
    State
], Page1.prototype, "current", void 0);
__decorate([
    Watch('current')
], Page1.prototype, "handleCurrentWatch", null);
Page1 = __decorate([
    Component
], Page1);
export default Page1;
